import type { FilterOption } from '../types/Filter';

interface FilterOptionUidValuePairs {
  uid: string;
  value: FilterOption['value'];
}

export const setOptionsValues = (
  filterOptions: FilterOption[],
  optionUidValuePairs: FilterOptionUidValuePairs[],
) => {
  return filterOptions.map((option) => {
    const newOptionState = optionUidValuePairs.find(({ uid }) => option.uid === uid);

    if (newOptionState) {
      return {
        ...option,
        active: newOptionState.value !== null,
        value: newOptionState.value,
      };
    }

    return option;
  });
};

export const setOptionActiveByValue = (
  filterOptions: FilterOption[],
  value: FilterOption['value'],
  active: boolean,
): FilterOption[] => {
  return filterOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    }

    return option;
  });
};

export const setOptionToActiveRemoveOthers = (
  filterOptions: FilterOption[],
  value: FilterOption['value'],
): FilterOption[] => {
  const activatedOption = filterOptions.find((option) => option.value === value)!;

  return [{ ...activatedOption, active: true }];
};

export const setOptionToActiveSetOthersToInactive = (
  filterOptions: FilterOption[],
  value: FilterOption['value'],
) => {
  return filterOptions.map((option) => {
    return {
      ...option,
      active: option.value === value,
    };
  });
};
